export default __webpack_public_path__ + "static/char-s-11-en-9a5d2fb7e40f6582732b0a817747ab98.webp";